exports.list = {
    path: '/satuan',
    name: 'satuan_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/satuan/List.vue"),
}
exports.show = {
    path: '/satuan/show/:id',
    name: 'satuan_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/satuan/Show.vue"),
}